import { Injectable } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatDateRangeSelectionStrategy, DateRange } from '@angular/material/datepicker';

@Injectable()
export class MaxRangeSelectionStrategy<D> implements MatDateRangeSelectionStrategy<D> {
  start!: D | null;
  public delta!: number;
  constructor(private readonly _dateAdapter: DateAdapter<D>) {}

  selectionFinished(date: D, currentRange: DateRange<D>) {
    let { start, end } = currentRange;
    if (start == null || (start != null && end != null)) {
      start = date;
      end = null;
    } else if (end == null) {
      const maxDate = this._dateAdapter.addCalendarDays(start, this.delta);
      if (date != null) {
        if (date < start) {
          start = date;
          end = null;
        } else {
          end = date > maxDate ? maxDate : date;
        }
      }
    }

    return new DateRange<D>(start, end);
  }

  createPreview(activeDate: D | null, currentRange: DateRange<D>): DateRange<D> {
    if (currentRange.start != null && currentRange.end == null) {
      const maxDate = this._dateAdapter.addCalendarDays(currentRange.start, this.delta);
      let rangeEnd: D | null = null;
      if (activeDate != null) {
        rangeEnd = activeDate > maxDate ? maxDate : activeDate;
      }

      return new DateRange(currentRange.start, rangeEnd);
    }

    return new DateRange<D>(null, null);
  }
}
